<div class="row">
    <div class="col-lg-12">
        <div class="clearfix">            
            <ul class="nav nav-tabs custom top">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#ta"><strong>Drivers Fitness Test</strong></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#tb"><strong>Vehicles Checks</strong></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#tc"><strong>Mass Management</strong></a>
                </li>
            </ul>
        </div>
        <div class="tab-content top">
            <!-- TAB A -->
            <div class="tab-pane active" id="ta">
                <app-driverfitnesstests></app-driverfitnesstests>
            </div>   <!-- END TAB A -->
            
            <!-- TAB B -->
            <div class="tab-pane" id="tb">
                <app-vehiclechecks></app-vehiclechecks>
            </div> <!-- END TAB B -->

            <!-- TAB C -->
            <div class="tab-pane" id="tc">
                <app-massmanagement></app-massmanagement>
            </div>  
            <!-- END OF TAB C -->
        </div>
    </div>
</div>


